import { palette } from '../tokens.ts';

export interface ScaleOfMilesProps {
  /** Caption under the bar, e.g. "Nautical Miles" (localised by the caller). */
  caption: string;
  color?: string;
  fill?: string;
  className?: string;
}

/** A chart's scale bar with alternating inked segments. Purely decorative. */
export function ScaleOfMiles({
  caption,
  color = palette.ink,
  fill = palette.paper,
  className,
}: ScaleOfMilesProps) {
  const segments = 6;
  const width = 30;
  return (
    <svg
      className={className}
      viewBox={`-12 0 ${segments * width + 24} 50`}
      width={segments * width + 24}
      height={50}
      aria-hidden="true"
      focusable="false"
    >
      <g stroke={color} strokeWidth={0.8}>
        {Array.from({ length: segments }, (_, i) => (
          <rect key={i} x={i * width} y={6} width={width} height={5} fill={i % 2 === 0 ? color : fill} />
        ))}
        <rect x={0} y={11} width={segments * width} height={2.5} fill="none" />
      </g>
      <g fill={color} fontFamily="'PT Serif', serif" fontSize={14} textAnchor="middle">
        {Array.from({ length: segments / 2 + 1 }, (_, i) => (
          <text key={i} x={i * width * 2} y={28}>
            {i * 10}
          </text>
        ))}
        <text x={(segments * width) / 2} y={46}>
          {caption}
        </text>
      </g>
    </svg>
  );
}
